import { CardHeader, FormControlLabel, Grid, Switch, Typography, generateUtilityClasses } from '@mui/material'
import { styled } from '@mui/system'
import React from 'react'
import RadioField from '../../../../../ui/RadioField'
import { TextField } from '../../../../../ui'
import DropdownFieldSearch from '../../../../../ui/DropdownFieldSearch'
import { useSelector } from 'react-redux'
import { getContactSuffixes } from '../../../../../redux/slices/userDropdownSlice'
import { Field, useFormState } from 'react-final-form'

const classes = generateUtilityClasses('Grid', ['root', 'row', 'firstReferralWrap'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.firstReferralWrap}`]: {
    margin: theme.spacing(0, 0, 2, 0),
  },
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
}))

const ReferralForm = () => {
  const { values } = useFormState()
  const contactSuffixes = useSelector(getContactSuffixes)
  const accountOptions: any[] = [
    { key: 'individual', value: 'Individual' },
    { key: 'business', value: 'Business' },
  ]
  return (
    <>
      <CardHeader title='Referral' />
      <Grid container spacing={2} padding={3}>
        <Field name='AccountType'>
          {(props) => (
            <div>
              <FormControlLabel
                sx={{ m: 2, top: 0, position: 'absolute', left: 80 }}
                control={
                  <Switch
                    name={props.input.name}
                    checked={props.input.value === 'business'}
                    onChange={(e) => {
                      props.input.onChange(e.target.checked ? 'business' : 'individual')
                    }}
                  />
                }
                label='Business'
              />
            </div>
          )}
        </Field>

        {values?.AccountType === 'business' ? (
          <Grid item xs={6}>
            <TextField name='BusinessName' label='Business Name' fullWidth />
          </Grid>
        ) : (
          <>
            <Grid item xs={6}>
              <TextField name='FirstName' label='First Name' fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField name='MiddleName' label='Middle Name' fullWidth />
            </Grid>
            <Grid item xs={4}>
              <TextField name='LastName' label='Last Name' fullWidth />
            </Grid>
            <Grid item xs={2}>
              <DropdownFieldSearch name='Suffix' label='Suffix' options={contactSuffixes} optionKey='Suffix' optionValue='Suffix' optionNone />
            </Grid>
            <Grid item xs={6}>
              <TextField name='NickName' label='Preferred Name' fullWidth />
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}

export default ReferralForm
